// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1we-1","description":"PatientConsentPreview_description__3GMWp"};